__turbopack_context__.v({
  "animateRefresh": "index-module__H-VssW__animateRefresh",
  "card": "index-module__H-VssW__card",
  "center": "index-module__H-VssW__center",
  "code": "index-module__H-VssW__code",
  "content": "index-module__H-VssW__content",
  "description": "index-module__H-VssW__description",
  "grid": "index-module__H-VssW__grid",
  "logo": "index-module__H-VssW__logo",
  "main": "index-module__H-VssW__main",
  "rotate": "index-module__H-VssW__rotate",
  "rotateRefresh": "index-module__H-VssW__rotateRefresh",
  "vercelLogo": "index-module__H-VssW__vercelLogo",
});
